import { Button } from '@mui/material'
import { getButtonStyles } from './MobileButton.styles'
import styles from './MobileButton.module.scss'

export interface MobileButtonProps {
  onClick: () => void
  variant: 'text' | 'outlined' | 'contained'
  label: string
}

function MobileButton(props: MobileButtonProps) {
  const { onClick, variant, label } = props
  const buttonStyles = getButtonStyles(variant)

  return (
    <Button
      onClick={onClick}
      type="button"
      variant={variant}
      sx={buttonStyles}
      disableRipple
    >
      <p className={`body-bold-medium ${styles.styledParagraph}`}>{label}</p>
    </Button>
  )
}

export default MobileButton
